import { Button } from '@/components/ui/button';
import AppLayout from '@/layouts/app-layout';
import { Head } from '@inertiajs/react';
import { AlertCircle, ArrowLeft } from 'lucide-react';

interface Props {
    status: number;
    details?: string;
}

export default function ErrorPage({ status, details }: Props) {
    const title = {
        503: '503: Service Unavailable',
        500: '500: Server Error',
        404: '404: Page Not Found',
        403: '403: Forbidden',
    }[status];

    const description = {
        503: 'Sorry, we are doing some maintenance. Please check back soon.',
        500: 'Whoops, something went wrong on our servers.',
        404: 'Sorry, the page you are looking for does not exist.',
        403: 'Sorry, you are forbidden from accessing this page.',
    }[status];

    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <AppLayout>
            <Head title={title} />
            <main className="mt-20 flex w-full flex-col items-center justify-center gap-6 p-4">
                <div className="bg-destructive/10 flex h-20 w-20 items-center justify-center rounded-full">
                    <AlertCircle className="text-destructive h-10 w-10" />
                </div>

                <div className="flex max-w-lg flex-col items-center gap-3 text-center">
                    <h1 className="text-3xl font-bold">{title}</h1>
                    <p className="text-muted-foreground text-lg">{description}</p>
                </div>

                <Button onClick={handleGoBack} className="gap-2 transition-all hover:gap-3">
                    <ArrowLeft className="h-4 w-4" />
                    Go back
                </Button>

                {details && (
                    <div className="max-w-full min-w-lg">
                        <h3 className="text-lg font-bold">Exception Details</h3>
                        <pre className="rounded bg-gray-300 p-3 text-left whitespace-pre-line">{details}</pre>
                    </div>
                )}
            </main>
        </AppLayout>
    );
}
